
import React from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import CarouselItemBg from "components/shared/CarouselItemBg"

const ArticleStyled = styled.article`
    margin-bottom: 0;		
    width: 100%;
    display: block;
    position: relative;
    border: 2px solid ${props => props.theme.colors.stone};

    ${props => props.type === "ColumnedImageWithText" && css`
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15));
        display: flex;
        flex-direction: column;
    `}

    > a {
        line-height: 0;
        display: block;
    }

    p.date {
        font-size: ${props => props.theme.font.size.base};
    }

    h2 {
        font-size: ${props => props.theme.font.size.base};
        font-family: ${props => props.theme.font.family.bold};
        text-transform: uppercase;
        color: ${props => props.theme.colors.tertiary}; 
        margin: 0;
        padding: 0;

        ${props => props.type === "WpRecipe" && css`
            color: ${props => props.theme.colors.black}; 
        `}

        ${props => props.type === "WpThingtodo" && css`
            color: ${props => props.theme.colors.purple}; 
        `}

        ${props => props.type === "ColumnedImageWithText" && css`
            color: ${props => props.theme.colors.primary};
        `}

        a {
            text-decoration: none;
            ${props => props.type === "WpRecipe" && css`
                color: ${props => props.theme.colors.black}; 
            `}

            ${props => props.type === "WpThingtodo" && css`
                color: ${props => props.theme.colors.purple}; 
            `}

            ${props => props.type === "ColumnedImageWithText" && css`
                color: ${props => props.theme.colors.primary};
            `}
        }
    }

    p.more {  
        font-size: ${props => props.theme.font.size.base};
    }

    .news-content {
        position: absolute;
        padding: 1rem;
        bottom: 1rem;
        left: 1rem;
        width: calc(100% - 2rem);
        background-color: white;
        color: black;
        font-size: ${props => props.theme.font.size.sm};
        z-index: 10;

        ${props => props.type === "ColumnedImageWithText" && css`
            position: relative;
            bottom: 0;
            left: 0;
            width: 100%;
            flex-grow: 1;
        `}

        p {
            &:last-child {
                margin: 0;
            }
        }
    }

    &:hover {
        ${props => props.borderOnHover === "yes" && css`
            border: 4px solid yellow;
        `}

        .hoverBg {
            opacity: 1;
        }
    }
` 

const Excerpt = styled.div`
    font-family: ${props => props.theme.font.family.bold};
`
 
const CarouselItem = (props) => {
    return(
        <ArticleStyled type={props.type}>
            {props.image && props.image.localFile &&
                <Link to={props.url} className="position-relative" target={props.external ? "_blank" : false}>
                    <GatsbyImage
                        image={props.image.localFile.childImageSharp.gatsbyImageData}
                        alt={props.image.altText}
                    /> 
                    {props.url &&
                        <CarouselItemBg 
                            className="hoverBg" 
                            type={props.type}
                        >
                            <div>Read More</div>
                        </CarouselItemBg>
                    }
                </Link>
            }
            <div className="news-content">
                {props.url && props.title ? (
                    <h2>
                        <Link to={props.url} target={props.external ? "_blank" : false}>
                            {props.title}
                        </Link>
                    </h2>
                ) : (
                    <>
                        {props.title && 
                            <h2>
                                {props.title}
                            </h2>
                        }
                    </>
                )} 
                {props.excerpt && 
                    <Excerpt dangerouslySetInnerHTML={{ __html: props.excerpt }} className="pt-2" />
                }
            </div>
        </ArticleStyled>
    )
}

export default CarouselItem